module.exports = __webpack_public_path__ + "flyer_background_christmas_ornament_116-2cb570396c42d3e9cd8cd8b6268b57e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_christmas_ornament_116.jpg
// module id = 1620
// module chunks = 1